// extracted by mini-css-extract-plugin
module.exports = {"logo":"SidePane_logo__3vZO1","SelectedTaskInput":"SidePane_SelectedTaskInput__1nreK"};